import React from 'react';
import FooterBanner from './form';
import { getFooterBanner, updateFooterBanner } from '../../modules/Api';
import { normalizer } from '../Coupons/pipeline';
import { notification } from 'antd';
import history from '../../modules/History';

class EditFooterBanner extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }

    }
    componentDidMount() {
        this.fetchCouponDetail();
    }
    fetchCouponDetail() {
        const id = this.props.match.params.id;
        getFooterBanner(id, data => { this.setState({ data: data.data }) });
    }
    submit(values) {
        if (this.state.submitted) {
            return;
        }
        this.setState({ submitted: true });
        const id = this.props.match.params.id;
        const formData = normalizer(values, this.state.data);
        updateFooterBanner(id, formData, () => {
            notification.open({
                message: `بنر با موفقیت ویرایش شد!`,
                description: ``
            });
            this.setState({ submitted: false });
            history.item.push(`/footer-banner`);
        })
    }
    render() {
        if (!this.state.data.id) {
            return (<div>لطفا منتظر بمانید</div>);
        }
        return (<div><FooterBanner initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted} /></div>);
    }
}

export default EditFooterBanner;


// WEBPACK FOOTER //
// ./src/containers/FooterBanner/edit.js